var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTempAvaliacao(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 394,
    viewBox: "0 0 182 394",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 182,
    height: 394,
    rx: 22,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6075,
    y: 110.201,
    width: 154.785,
    height: 66.8013,
    rx: 20,
    fill: "#D9D9D9",
    fillOpacity: 0.38
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6075,
    y: 182.108,
    width: 154.785,
    height: 20.8488,
    rx: 10.4244,
    fill: "#D9D9D9",
    fillOpacity: 0.38
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4616 189.342L29.3412 193.287L34.2207 189.342L35.7197 190.556L29.3412 195.724L22.9626 190.556L24.4616 189.342Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7197 116.956C35.7197 116.283 35.1456 115.732 34.444 115.732H24.2383C23.5367 115.732 22.9626 116.283 22.9626 116.956V124.295C22.9626 124.968 23.5367 125.519 24.2383 125.519H34.444C35.1456 125.519 35.7197 124.968 35.7197 124.295V116.956ZM34.444 116.956L29.3412 120.014L24.2383 116.956H34.444ZM34.444 124.295H24.2383V118.179L29.3412 121.237L34.444 118.179V124.295Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4626 82.7282L63.8765 82.3117L62.0841 77.8643L60.2918 82.3184L55.7056 82.7282L59.1883 85.9059L58.1422 90.6288L62.0841 88.1229L66.026 90.6288L64.9864 85.9059L68.4626 82.7282ZM62.0841 86.8666L59.6858 88.3917L60.3237 85.5163L58.206 83.5814L60.9998 83.3262L62.0841 80.6187L63.1749 83.3329L65.9686 83.5882L63.851 85.523L64.4888 88.3984L62.0841 86.8666Z",
    fill: "#CCCCCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9206 82.7282L78.3344 82.3117L76.5421 77.8643L74.7497 82.3184L70.1636 82.7282L73.6462 85.9059L72.6002 90.6288L76.5421 88.1229L80.484 90.6288L79.4443 85.9059L82.9206 82.7282ZM76.5421 86.8666L74.1438 88.3917L74.7816 85.5163L72.6639 83.5814L75.4577 83.3262L76.5421 80.6187L77.6328 83.3329L80.4266 83.5882L78.3089 85.523L78.9468 88.3984L76.5421 86.8666Z",
    fill: "#CCCCCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3785 82.7282L92.7924 82.3117L91 77.8643L89.2077 82.3184L84.6215 82.7282L88.1042 85.9059L87.0581 90.6288L91 88.1229L94.9419 90.6288L93.9022 85.9059L97.3785 82.7282ZM91 86.8666L88.6017 88.3917L89.2396 85.5163L87.1219 83.5814L89.9157 83.3262L91 80.6187L92.0907 83.3329L94.8845 83.5882L92.7669 85.523L93.4047 88.3984L91 86.8666Z",
    fill: "#CCCCCC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M111.836 82.7282L107.25 82.3117L105.458 77.8643L103.666 82.3184L99.0795 82.7282L102.562 85.9059L101.516 90.6288L105.458 88.1229L109.4 90.6288L108.36 85.9059L111.836 82.7282ZM105.458 86.8666L103.06 88.3917L103.698 85.5163L101.58 83.5814L104.374 83.3262L105.458 80.6187L106.549 83.3329L109.342 83.5882L107.225 85.523L107.863 88.3984L105.458 86.8666Z",
    fill: "#CCCCCC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126.294 82.7282L121.708 82.3117L119.916 77.8643L118.124 82.3184L113.537 82.7282L117.02 85.9059L115.974 90.6288L119.916 88.1229L123.858 90.6288L122.818 85.9059L126.294 82.7282ZM119.916 86.8666L117.518 88.3917L118.155 85.5163L116.038 83.5814L118.832 83.3262L119.916 80.6187L121.007 83.3329L123.8 83.5882L121.683 85.523L122.321 88.3984L119.916 86.8666Z",
    fill: "#CCCCCC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0841 88.1229L66.026 90.6288L64.98 85.9059L68.4626 82.7282L63.8765 82.3184L62.0841 77.8643L60.2918 82.3184L55.7056 82.7282L59.1883 85.9059L58.1422 90.6288L62.0841 88.1229Z",
    fill: "#CCCCCC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5421 88.1229L80.484 90.6288L79.4379 85.9059L82.9206 82.7282L78.3344 82.3184L76.5421 77.8643L74.7497 82.3184L70.1636 82.7282L73.6462 85.9059L72.6002 90.6288L76.5421 88.1229Z",
    fill: "#CCCCCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M91 88.1229L94.9419 90.6288L93.8959 85.9059L97.3785 82.7282L92.7924 82.3184L91 77.8643L89.2077 82.3184L84.6215 82.7282L88.1042 85.9059L87.0581 90.6288L91 88.1229Z",
    fill: "#CCCCCC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M105.458 88.1229L109.4 90.6288L108.354 85.9059L111.836 82.7282L107.25 82.3184L105.458 77.8643L103.666 82.3184L99.0795 82.7282L102.562 85.9059L101.516 90.6288L105.458 88.1229Z",
    fill: "#CCCCCC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M119.916 88.1229L123.858 90.6288L122.812 85.9059L126.294 82.7282L121.708 82.3184L119.916 77.8643L118.124 82.3184L113.537 82.7282L117.02 85.9059L115.974 90.6288L119.916 88.1229Z",
    fill: "#CCCCCC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_170_6992)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.1355,
    y: 328.901,
    width: 143.304,
    height: 34.0389,
    rx: 17.0194,
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_170_6992",
    x: 18.1355,
    y: 328.901,
    width: 145.304,
    height: 49.0391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 10,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_170_6992"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_170_6992"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_170_6992",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempAvaliacao);
export default __webpack_public_path__ + "static/media/TempAvaliacao.fbaaadb29b097847b84cb60af12bbf43.svg";
export { ForwardRef as ReactComponent };